import "../tool.js";
import "../modals/assessment_picker.js";

// NOTE: we don't use fat arrows because Sparkle.PageBuilder.Tool is not a prototype, it's simply a function that extends
//       an object, so right now `this` is `window`.
Sparkle.PageBuilder.Tool({
  name: "assessment-picker",
  templateId: "assessment-picker",

  bind(component) {
    return jQuery(this.element).on("click", "button", this.editForm.bind(this));
  },

  unbind(element) {
    return jQuery(this.element).find("button").off();
  },

  editForm() {
    const modal = new Sparkle.PageBuilder.Modal.AssessmentPicker({
      selectedValue: this.component.context,
      onComplete: this.onComplete.bind(this),
    });

    return modal.show();
  },

  onComplete(value) {
    this.component.save(value);
    return this.component.render();
  },
});
